import { useDispatch, useSelector } from 'react-redux'
import useGetVsic from '../../common/category/useGetVsic'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { COMPONENTS } from '../../routers/constants'
import './i18n'
import classes from './index.module.scss'
import Pdf from './pdf'
import { PreferenceSetting } from './preferenceSetting'
import DynamicReportService from './store/service'
import {
  selectLoading,
  selectTemplateIds,
  selectTemplates,
  selectTotalRecord,
} from './store/slice'
import {
  deleteTemplatesThunk,
  getTemplatesThunk,
  updateTemplateThunk,
} from './store/thunk'

const DynamicReport = () => {
  const dispatch = useDispatch()
  const { vsics } = useGetVsic()
  const loadingTemplate = useSelector(selectLoading('template'))
  const templates = useSelector(selectTemplates)
  const totalRecord = useSelector(selectTotalRecord)
  const templateIds = useSelector(selectTemplateIds)

  const callApiTemplates = (param) => {
    dispatch(getTemplatesThunk(param))
  }

  const deleteTemplate = (data) => {
    dispatch(
      deleteTemplatesThunk({
        ...data,
        param: {
          ids: data.param.ids,
        },
      }),
    )
  }

  const updateTemplate = (data) => {
    dispatch(updateTemplateThunk(data))
  }

  const saveTemplate = async (data) => {
    try {
      if (data.templateId) {
        const res = await DynamicReportService.updateTemplate({
          id: data.templateId,
          templateName: data.templateName,
          templateData: JSON.stringify(data.templateData),
          companyType: data.companyType,
        })
        return res.success
      } else {
        const res = await DynamicReportService.saveTemplate({
          templateName: data.templateName,
          templateData: JSON.stringify(data.templateData),
          companyType: data.companyType,
        })
        return res.success
      }
    } catch {
      return false
    }
  }

  if (!vsics.length) {
    return <Loading />
  }

  return (
    <Element
      className="dFlex justifyContentCenter h100"
      style={{ backgroundColor: '#F3F3F3' }}
    >
      <Element
        className={classes.dynamicReportContainer}
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <PreferenceSetting
          template={{
            callApi: callApiTemplates,
            data: templates,
            ids: templateIds,
            loading: loadingTemplate,
            total: totalRecord,
            deleteTemplate,
            updateTemplate,
          }}
          detailTemplate={{
            saveTemplate,
            path: COMPONENTS.dynamicReport.route,
          }}
        />
      </Element>
      <Pdf />
    </Element>
  )
}

export default DynamicReport
